var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"editor-snackbar"}},[(_vm.show)?_c('div',{staticClass:"editor-snackbar",style:(_vm.toastStyle)},[_vm._v(" "+_vm._s(_vm.editorSnackbarMessage)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }